export const colors = {
    grey: {
        grey80: '#282828',
        grey70: '#404040',
        grey60: '#666666',
        grey50: '#A6A6A6',
        grey40: '#CCCCCC',
        grey30: '#E6E6E6',
        grey20: '#F2F2F2',
        grey10: '#F9F9F9',
        grey0: '#FFFFFF',
    },
    red: {
        red60: '#BB1B18',
        red50: '#DA291C',
        red30: '#FFB3B3',
        red20: '#FDDDDD',
        red10: '#FFF0F0',
    },
    green: {
        green70: '#6C8524',
        green60: '#819F2B',
        green50: '#A2C14E',
        green20: '#ECF2C2',
    },
    brown: {
        brown70: '#776654',
        brown30: '#E6D1B8',
        brown20: '#EFE8DF',
    },
    sky: {
        sky30: '#B0DFDB',
        sky20: '#CEEEEC',
    },
    aqua: {
        aqua70: '#1C818D',
        aqua30: '#D1EBEE',
        aqua20: '#E4F3F5',
    },
    yellow: {
        yellow60: '#B69D03',
        yellow30: '#FCE06D',
        yellow20: '#FCF0BE'
    },
    moss: {
        moss70: '#5F6E57',
    },
    graph: {
        graphAqua70: '#268C99',
        graphAqua60: '#52A1AB',
        graphAqua50: '#75B5BD',
        graphAqua40: '#99CCCC',
        graphAqua30: '#B0DFDB',
        graphMoss70: '#4F5C4A',
        graphMoss60: '#5F6E57',
        graphMoss50: '#828F75',
        graphMoss40: '#A6AB99',
        graphMoss30: '#C9C9BA',
    },
};
